import { TournamentsResponse } from '~/composables/pocketbase.types';

export const useTournamentsStore = defineStore('tournaments', () => {
	const activeTournament = ref<TournamentsResponse | null>(null);
	const allTournaments = ref<TournamentsResponse[]>([]);
	let loaded = false;

	async function fetch(forceReload?: boolean) {
		if (loaded && !forceReload) return;
		const pb = usePocketBase();
		allTournaments.value = await pb.collection('tournaments').getFullList({ requestKey: null });
		activeTournament.value = allTournaments.value.find(t => t.is_active) ?? null;
		loaded = true;
	}

	const activeTournamentId = computed(() => activeTournament.value?.id ?? '');

	async function setActive(tournamentId: string) {
		const pb = usePocketBase();
		if (activeTournament.value) {
			await pb.collection('tournaments').update(activeTournament.value.id, { is_active: false });
		}
		await pb.collection('tournaments').update(tournamentId, { is_active: true });
		await fetch(true);
	}

	async function createTournament(data: Partial<TournamentsResponse>) {
		const pb = usePocketBase();
		await pb.collection('tournaments').create(data);
		await fetch(true);
	}

	async function updateTournament(id: string, data: Partial<TournamentsResponse>) {
		const pb = usePocketBase();
		await pb.collection('tournaments').update(id, data);
		await fetch(true);
	}

	async function deleteTournament(id: string) {
		const pb = usePocketBase();
		await pb.collection('tournaments').delete(id);
		await fetch(true);
	}

	async function resolve(tournamentId: string): Promise<string> {
		try {
			const pb = usePocketBase();
			const result = await pb.send(`/admin/tournaments/${tournamentId}/resolve`, { method: 'POST' });
			return (result as any).message as string;
		} catch (error) {
			return 'Error: ' + error;
		}
	}

	fetch();

	return { activeTournament, allTournaments, activeTournamentId, fetch, setActive, createTournament, updateTournament, deleteTournament, resolve };
});
